<template>
  <div class="troubleshoot container">
    <img class="wave-top" src="@/assets/img/wave_top_page.png" />
    <img class="wave-top-mobile" src="@/assets/img/wave_top_mobile.png" />

    <div class="circle-yellow circle1 animate-growing"></div>
    <div class="circle-yellow circle2 animate-shrinking"></div>
    <div class="circle-cyan animate-shrinking"></div>
    <div class="circle-orange animate-shrinking"></div>

    <img class="wave-bottom" src="@/assets/img/wave_bottom_page.png" />

    <section class="main-menu" v-show="!activeCategory">
      <h1 class="main-title">
        Troubleshoot
      </h1>

      <div class="flex-wrapper">
        <troubleshoot-menu
          title="Software"
          :menu-content="softwareContent.map(i => i.title)"
          @input="viewContent('software', $event)"
        >
        </troubleshoot-menu>

        <troubleshoot-menu
          v-if="hardwareContent"
          title="Hardware"
          :menu-content="hardwareContent.map(i => i.title)"
          @input="viewContent('hardware', $event)"
        >
        </troubleshoot-menu>
      </div>
    </section>

    <troubleshoot-content
      :menu-list="
        activeCategory === 'software' ? softwareContent : hardwareContent
      "
      :active-content="activeContent"
      :active-category="activeCategory"
      v-if="activeCategory"
      @input="viewContent(activeCategory, $event)"
      @back="clear()"
    >
    </troubleshoot-content>
  </div>
</template>

<script>
import TroubleshootMenu from "@/components/troubleshoot/TroubleshootMenu.vue";
import TroubleshootContent from "@/components/troubleshoot/TroubleshootContent.vue";

export default {
  data() {
    return {
      activeCategory: "",
      activeContent: -1,

      softwareContent: [
        {
          title: `Can't scan/detect the band`,
          content: [
            {
              instructions: [
                `Make sure to turn the location “ON’’ for a more accurate Bluetooth detection.`,
                `Check if the Bluetooth is on. Perhaps, turn on/off Bluetooth to reset it in the phone. `,
                `Make sure the band is on with the blinking blue light. When connected to the app, the band sensor (green light at the bottom) will turn on and the blue light will stop blinking. `
              ]
            }
          ]
        },

        {
          title: `Can't link to a band`,
          content: [
            {
              instructions: [
                `Check if there are a lot of Bluetooth devices around you.`,
                `Scan Bluetooth devices and press stop when band is seen, then try to connect. You might need to do this a few times as there would be possible interference from other devices in the public space.`,
                `If the two above didn’t work, restart the app.`
              ]
            }
          ]
        },

        {
          title: `Can't fetch any data even connected to the internet`,
          content: [
            {
              instructions: [`Clear cache or data then try to log in again.`]
            },

            {
              subtitle: `How to Clear App Cache`,
              instructions: [
                `Open the Settings of your phone.`,
                `Select Apps or Application`,
                `Find and select the application you want to clear cache and tap its listing`,
                `Tap "Storage"`,
                `Tap Cache`,
                `Tap the Clear cache button.`
              ]
            },

            {
              subtitle: `How to Clear App Data`,
              instructions: [
                `Open the Settings of your phone.`,
                `Select Apps or Application`,
                `Find and select the application you want to clear data and tap its listing.`,
                `Tap "Storage" `,
                `Tap "Data"`,
                `Tap the Clear data button.`
              ]
            }
          ]
        },

        {
          title: `App crashed after update`,
          content: [
            {
              instructions: [`Clear cache or data then try to log in again.`]
            },

            {
              subtitle: `How to Clear App Cache`,
              instructions: [
                `Open the Settings of your phone.`,
                `Select Apps or Application`,
                `Find and select the application you want to clear cache and tap its listing`,
                `Tap "Storage"`,
                `Tap Cache`,
                `Tap the Clear cache button.`
              ]
            },

            {
              subtitle: `How to Clear App Data`,
              instructions: [
                `Open the Settings of your phone.`,
                `Select Apps or Application`,
                `Find and select the application you want to clear data and tap its listing.`,
                `Tap "Storage" `,
                `Tap "Data"`,
                `Tap the Clear data button.`
              ]
            }
          ]
        },

        {
          title: `Forgot Password`,
          content: [
            {
              instructions: [
                `Tap log in, input valid email address then click next.`,
                `Tap “Forgot password?” and enter the email address you registered`,
                `Tap “reset password” and check your email for your temporary password (temporary password will expire within 60 days).`
              ]
            },

            {
              subtitle: `Change Password:`,
              instructions: [
                `Login to Upmood using temporary password`,
                `Go to account tab on the dashboard`,
                `Tap "settings"`,
                `Tap "account"`,
                `Tap "password"`,
                `Enter the temporary password in current password textfield`,
                `Input new password in "new password" and "confirm password" textfield`,
                `Confirm new password by selecting the “change password” button`
              ]
            }
          ]
        }
      ],

      hardwareContent: [
        {
          title: `Can't turn on the band`,
          content: [
            {
              instructions: [
                `Hold the Upmood logo on the device for 3 seconds to turn on the band.`,
                `Connect to the charger. Red light will turn on when it’s charging while blue light will indicate that it’s fully charged.`,
                `Check and  see if the green PPG sensor is on.`
              ]
            }
          ]
        },

        {
          title: `The band turns itself off`,
          content: [
            {
              instructions: [
                `Check the following conditions (1) the band is loosely wore, (2) arm hair is in between the sensor and skin and  (3) irregular skin tone because of tattoos. If experiencing any of these, kindly place the band in your inner wrist for a more effective sensor detection.`
              ]
            }
          ]
        },

        {
          title: `The band is not detectable by the app`,
          content: [
            {
              instructions: [
                `Make sure the band is fully charged.`,
                `Try restarting the band. `
              ]
            }
          ]
        }
      ]
    };
  },

  deactivated() {
    this.activeCategory = "";
    this.activeContent = -1;
  },

  methods: {
    viewContent(category, contentIndex) {
      this.activeCategory = category;
      this.activeContent = contentIndex;
    },

    clear() {
      this.activeCategory = "";
      this.activeContent = -1;
    }
  },

  components: {
    TroubleshootMenu,
    TroubleshootContent
  }
};
</script>

<style lang="scss" scoped>
.troubleshoot {
  min-height: calc(100vh - 200px);
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  margin-bottom: 130px;
  margin-top: 160px;

  @include mobile {
    margin: 50px 0;
    min-height: 100vh;
    padding-bottom: 100px;
  }

  .wave-top {
    position: absolute;
    top: -245px;
    width: 100%;
    right: -325px;

    @include mobile {
      display: none;
    }
  }

  .wave-top-mobile {
    display: none;

    @include mobile {
      position: absolute;
      top: -150px;
      width: 115%;
      height: 100px;
      display: block;
    }
  }

  .circle1 {
    position: absolute;
    height: 83px;
    width: 83px;
    top: -150px;
    left: 240px;

    @include mobile {
      height: 30px;
      width: 30px;
      top: -70px;
      left: 120px;
    }
  }

  .circle2 {
    position: absolute;
    height: 499px;
    width: 499px;
    bottom: -450px;
    right: -30px;

    @include mobile {
      height: 100px;
      width: 100px;
      bottom: 165px;
      right: unset;
      left: -75px;
    }
  }

  .circle-cyan {
    position: absolute;
    height: 376px;
    width: 376px;
    right: -235px;
    top: -90px;

    @include mobile {
      width: 100px;
      height: 100px;
      left: -50px;
      top: -25px;
    }
  }

  .circle-orange {
    position: absolute;
    height: 330px;
    width: 330px;
    left: -225px;
    top: 100px;

    @include mobile {
      width: 40px;
      height: 40px;
      top: 300px;
      left: unset;
      right: -15px;
    }
  }

  .wave-bottom {
    display: none;

    @include mobile {
      display: block;
      position: absolute;
      bottom: -60px;
      width: 800px;
      left: -160px;
      height: 110px;
    }
  }

  .main-menu {
    z-index: 2;
    width: 100%;

    h1 {
      border-bottom: 1px solid #cbd6d6;
      margin-bottom: 20px;
      padding-bottom: 20px;
      text-align: center;
      color: #4ccbb9;
      letter-spacing: 1.6px;

      @include mobile {
        padding-bottom: 0;
      }
    }

    .troubleshoot-menu {
      width: 49%;

      @include mobile {
        width: 100%;
        margin-bottom: 20px;
      }
    }

    .flex-wrapper {
      display: flex;
      justify-content: space-between;

      @include mobile {
        flex-direction: column;
        margin-bottom: 100px;
        padding: 0 20px;
      }
    }
  }
}
</style>
